<div class="custom-snackbar">
    <div class="container p-0">
        <div class="row">
            <div class="col">
                <h5 class="title">{{data.title}}</h5>
                <p *ngFor="let description of data.descriptions" class="description">{{description}}</p>
            </div>
            <div class="col-3 v-center">
                <button mat-button class="dismiss-button" (click)="dismiss()">{{data.action}}</button>
            </div>
        </div>
    </div>
</div>